import * as React from 'react';

import { Input, } from '../../../Shared/index';

import { requestPut } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

interface EditStudentAccountModalProps {
  close: () => void;
  onSuccess: (string) => void;
  student: any;
  classroom: any;
}

const FIRST_NAME = 'First name'
const LAST_NAME = 'Last name'
const USERNAME = 'Username'

export const EditStudentAccountModal = ({ close, onSuccess, student, classroom }: EditStudentAccountModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const splitName = student.name.split(' ')
  const [firstName, setFirstName] = React.useState<string>(splitName[0])
  const [lastName, setLastName] = React.useState<string>(splitName.slice(1).join(' '))
  const [username, setUsername] = React.useState<string>(student.username)
  const [timesSubmitted, setTimesSubmitted] = React.useState<number>(0)
  const [errors, setErrors] = React.useState<{ [key: string]: string }>({})

  const functionsById = {
    [FIRST_NAME]: setFirstName,
    [LAST_NAME]: setLastName,
    [USERNAME]: setUsername
  }

  function editStudentAccount() {
    const user = { name: `${firstName} ${lastName}`, username }
    requestPut(`/teachers/classrooms/${classroom.id}/students/${student.id}`, { user, }, (body) => {
      if (body && body.errors) {
        setErrors(body.errors)
        setTimesSubmitted(timesSubmitted + 1)
      } else {
        onSuccess('Student account saved')
        close()
      }
    })
  }

  function submitButtonClass() {
    let buttonClass = 'quill-button contained green medium focus-on-light';
    const originalSplitName = student.name.split(' ')
    const noChanges = originalSplitName[0] === firstName && originalSplitName[1] === lastName && student.username === username
    if (!firstName.length || !lastName.length || !username.length || noChanges) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }


  function handleInputChange(e) {
    const { target } = e
    const { id, value } = target
    const setterFunction = functionsById[id]
    setterFunction(value)
  }

  function handleClearField(e) {
    const { target } = e
    const { id } = target
    const setterFunction = functionsById[id]
    setterFunction('')
  }

  return (
    <div className="modal-container edit-student-account-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="editStudentAccountModalTitle"
        aria-modal="true"
        className="edit-student-account-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="editStudentAccountModalTitle">Edit your student account</h3>
        </div>
        <Input
          characterLimit={50}
          className="large bordered firstName"
          error={errors.firstName}
          handleCancel={handleClearField}
          handleChange={handleInputChange}
          id={FIRST_NAME}
          label={FIRST_NAME}
          timesSubmitted={timesSubmitted}
          type="text"
          value={firstName}
        />
        <Input
          characterLimit={50}
          className="large bordered lastName"
          error={errors.lastName}
          handleCancel={handleClearField}
          handleChange={handleInputChange}
          id={LAST_NAME}
          label={LAST_NAME}
          timesSubmitted={timesSubmitted}
          type="text"
          value={lastName}
        />
        <Input
          className="large bordered username"
          error={errors.username}
          handleCancel={handleClearField}
          handleChange={handleInputChange}
          id={USERNAME}
          label={USERNAME}
          timesSubmitted={timesSubmitted}
          type="text"
          value={username}
        />
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close}>Cancel</button>
          <button className={submitButtonClass()} onClick={editStudentAccount}>Save</button>
        </div>
      </div>
    </div>
  )
}

export default EditStudentAccountModal
